const rootReducer = (state = {}) => state;

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js